import { useEffect, useRef } from 'react';

const CustomDetailCellRenderer = (props) => {
  const { api, node, data, ExpandedComponent } = props;
  const containerRef = useRef(null);
  const resizeObserverRef = useRef(null);

  useEffect(() => {
    resizeObserverRef.current = new ResizeObserver((entries) => {
      requestAnimationFrame(() => {
        for (const entry of entries) {
          const newHeight = entry.contentRect.height;
          if (newHeight > 0 && node.rowHeight !== newHeight) {
            node.setRowHeight(newHeight);
            api.onRowHeightChanged();
          }
        }
      });
    });

    if (containerRef.current) {
      resizeObserverRef.current.observe(containerRef.current);
    }

    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    };
  }, [api, node]);

  return (
    <div ref={containerRef}>
      <ExpandedComponent {...props} src={data?.details} />
    </div>
  );
};

export default CustomDetailCellRenderer;
